import { Component } from '@angular/core';

@Component({
  templateUrl: './coupons.page.html',
})

/**
 * Page that displays a list of coupons with filters
 */
export class CouponsPage {}
